module.exports = __webpack_public_path__ + "static/media/matching-score-name-background.339afefd.png";